namespace TabAurous.Common {
    export enum MarkUpRateType {
        Fixed = 1,
        Dynamic = 2
    }
    Serenity.Decorators.registerEnumType(MarkUpRateType, 'TabAurous.Common.MarkUpRateType', 'Administration.MarkUpRateType');
}
